module.exports = __webpack_public_path__ + "assets/img/ecg-detail-back-1.80963f59.png";